const volunteers=
  [
    {
     "id": 1,
      "name":"Child Support",
      "img": "https://i.ibb.co/hmF7cBs/child-Support.png",
      "bgColor":"#FFBD3E"
    },
    {
     "id": 2,    
      "name":"Refuge Shelter",
     "img": "https://i.ibb.co/0tfg5qc/refuse-Shelter.png",
     "bgColor":"#FF7044"
    },
    {
     "id": 3,
      "name":"Food Charity",
    "img": "https://i.ibb.co/8m2HSk3/food-Charity.png",
    "bgColor":"#3F90FC"
    },
    {
     "id": 4,
      "name":"Host a clothing swap.",
    "img": "https://i.ibb.co/wS8VqgJ/cloth-Swap.png",
    "bgColor":"#421FCF"
    },
    {
     "id": 5,
      "name":"Host a river clean.",
    "img": "https://i.ibb.co/JCY1xtr/river-Clean.png",
    "bgColor":"#3F90FC"
    },
    {
     "id": 6,
      "name":"Clean water for children",
      "img": "https://i.ibb.co/kH2JsVW/clean-Water.png",
      "bgColor":"#421FCF"
    },
    {
     "id": 7,
      "name":"Good Education",
    "img": "https://i.ibb.co/PmX59wF/good-Education.png",
    "bgColor":"#FFBD3E"
    },
    {
     "id": 8,
      "name":"New Books for Children",
    "img": "https://i.ibb.co/9gZVFbs/newBooks.png",
    "bgColor":"#FF7044"
    },
    {
     "id": 9,
      "name":"Host a study group.",
    "img": "https://i.ibb.co/4Tn6Rrg/study-Group.png",
    "bgColor":"#FFBD3E"
    },
    {
     "id": 10,
      "name":"Build birdhouses for your neighbors.",
    "img": "https://i.ibb.co/Jm1FD34/bird-House.png",
    "bgColor":"#3F90FC"
    },
    {
     "id": 11,
      "name":"Organize books at the library.",
    "img": "https://i.ibb.co/sJLr4bV/library-Books.png",
    "bgColor":"#FF7044"
    },
    {
     "id": 12,    
      "name":"Give a seminar on driving safety.",
    "img": "https://i.ibb.co/Vx3p5FH/drive-Safety.png",
    "bgColor":"#421FCF"
    },
    {
     "id": 13,
      "name":"Give free music lessons.",
    "img": "https://i.ibb.co/f2m6GGJ/music-Lessons.png",
    "bgColor":"#421FCF"
    },
    {
     "id": 14,
      "name":"Teach people how to register to vote.",
    "img": "https://i.ibb.co/gJk7GhR/vote-Register.png",
    "bgColor":"#FFBD3E"
    },
    {
     "id": 15,
      "name":"Clean up your local park.",
    "img": "https://i.ibb.co/qj5F7kw/clearn-Park.png",
    "bgColor":"#3F90FC"
    },
    {
     "id": 16,
      "name":"Give IT help to local adults",
    "img": "https://i.ibb.co/KrKrxTV/ITHelp.png",
    "bgColor":"#FF7044"
    },
    {
     "id": 17,
      "name":"Foster a shelter animal.",
    "img": "https://i.ibb.co/qMtsnkj/animal-Shelter.png",
    "bgColor":"#FFBD3E"
    },
    {
     "id": 18,
      "name":"Babysit during PTA meetings.",
    "img": "https://i.ibb.co/j4hz0tj/babySit.png",
    "bgColor":"#3F90FC"
    },
    {
     "id": 19,
      "name":"Collect stuffed animals.",
    "img": "https://i.ibb.co/Hnym5Rj/stuffed-Animals.png",
    "bgColor":"#FF7044"
    },
    {
     "id": 20,
      "name":"Collect school supplies.",
    "img": "https://i.ibb.co/7jqgQMd/school-Suffiles.png",
    "bgColor":"#421FCF"
    }
  ];
  export default volunteers;